"use strict";

import "./icon.css";
import React from "react";
import classnames from "classnames";

export default class Icon extends React.Component {
	
	render() {
		const className = classnames(this.props.className, "mdi mdi-" + this.props.children)
		
		return (
			<i className={className}></i>
		);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/components/Icon/Icon.jsx